import Api from '@/services/Api'

export default {
    leaCiius(){
        return Api().get('leaCiius')
    },
}
